import React, {Component} from 'react';
import * as apis from '../../utils/apis';
import { connect } from "react-redux";

import DataGrid, {
    Column,
    Editing,
    Popup,
    Position,
    GroupPanel,
    FilterPanel,
    FilterRow,
    ColumnChooser,
    Scrolling,
    RequiredRule,
    FormItem
} from 'devextreme-react/ui/data-grid';
import { StringLengthRule } from 'devextreme-react/validator';


const getHeight = () => {
    return (window.innerHeight - 48)
}

class BookingTypesGrid extends Component {
    state = {
    };

    resize = () => {
        this.gridview.instance.option('height',getHeight());
      }
    
      componentDidMount() {
        window.addEventListener('resize', this.resize)
      }
      
      componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
      }

      setDefaultNewValues = (e) => {
          e.data.productive = true;
          e.data.active = true;
      }

      onToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            options: {
              icon: 'refresh',
              onClick: this.refreshGrid 
            }
          });
    }

    refreshGrid = () => {
        this.gridview.instance.refresh(true);
    }

    render() {
        return  (
            <DataGrid
            dataSource={apis.BookingTypeDataSource(this.props.user.access_token)}  
            noDataText="There are no booking types defined."
            rowAlternationEnabled={true}  
            showBorders={true}
            showRowLines={true}
            showColumnLines={true}  
            columnHidingEnabled={false}
            allowColumnReordering={true}
            allowColumnResizing={true}
            stateStoring={{ enabled: 'true',type: 'localStorage', storageKey: 'bookingTypes' }}
            height={getHeight }
            width="100%" ref={(gv) => {this.gridview = gv}} 
            onInitNewRow={this.setDefaultNewValues} onToolbarPreparing={this.onToolbarPreparing}
            >
        <Scrolling mode="virtual" />
        <GroupPanel visible={true} />
        <FilterRow visible={true} />
        <FilterPanel visible ={true} />
        <Editing
            mode={'popup'}
            allowUpdating={this.props.grants.rights.adminBookingTypes}
            allowDeleting={this.props.grants.rights.adminBookingTypes}
            allowAdding={this.props.grants.rights.adminBookingTypes} >
             <Popup title={'Booking Type'} showTitle={true} width={700} height={345}>
              <Position my={'center'} at={'center'} of={window} />
            </Popup>
        </Editing>
  
        <ColumnChooser enabled={true} />
        {/* <StateStoring enabled={true} storageKey="this.props.sectionId" /> */}

        <Column dataField={'id'} visible={false}>
            <FormItem visible={false} />
        </Column>
        <Column dataField={'description'} >
            <RequiredRule />
            <StringLengthRule max="100" message="The booking type description cannot exceed 100 characters."/>
        </Column>
        <Column dataField={'productive'} caption='Productive Time'>
           
        </Column>
        <Column dataField={'active'}>
           
        </Column>
       
 
        </DataGrid>
        );
    }


}

const mapStateToProps = (state) => {
    return {
        user: state.oidc.user,
        grants: state.rights
    };
  }

export default connect(mapStateToProps, null)(BookingTypesGrid)